/**
 * sub-menu-nav.js
 *
 * Handles toggling the secondary navigation sub menus
 */

class SubMenuNav {
    constructor() {
        this.elements = null;
        this.grabElements();

        if (this.elements.subMenuToggle.length) {
            this.bindEvents();
        }
    }

    grabElements() {
        this.elements = {
            window: jQuery(window),
            body: jQuery('body'),
            navigation: jQuery('#secondary-nav'),
            subMenuToggle: jQuery('.js-submenu-trigger'),
            parent: jQuery('.resource-links'),
            subMenu: jQuery('.js-sub-menu')
        };
    }

    bindEvents() {
        this.elements.subMenuToggle.on('click', this.handleSubMenu.bind(this));
        this.elements.body.on('keyup', this.closeSubmenuOnEsc.bind(this));
    }

    updateAriaAttrs(trigger, submenu) {
        trigger.attr('aria-expanded', 'true');
        submenu.attr('aria-hidden', 'false');
    }

    handleSubMenu(e) {
        e.preventDefault();

        const target = jQuery(e.currentTarget);
        const parent = jQuery(target.closest(this.elements.parent));
        const submenu = jQuery(parent.find(this.elements.subMenu));

        if (parent.hasClass('active')) {
            this.closeAllSubmenu();
        } else {
            this.closeAllSubmenu();
            parent.addClass('active');
            this.elements.navigation.addClass('submenu-open');
            this.updateAriaAttrs(target, submenu);
        }
    }

    closeAllSubmenu() {
        this.elements.navigation.removeClass('submenu-open');
        this.elements.parent.removeClass('active');
        this.elements.subMenuToggle.attr('aria-expanded', 'false');
        this.elements.subMenu.attr('aria-hidden', 'true');
    }

    closeSubmenuOnEsc(e) {
        if (
            e.key === 'Escape' &&
            this.elements.navigation.hasClass('submenu-open')
        ) {
            this.closeAllSubmenu();
        }
    }
}

jQuery(document).ready(function($) {
    window.subMenuNav = new SubMenuNav();
});
